import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityTiposRolState,
  entityTiposRolAdapter
} from './entity-tipos-rol.state';
import {
  entityTiposRolLoadFailure,
  entityTiposRolLoadRequest,
  entityTiposRolLoadSuccess,
  entityTiposRolUpdateSuccess
} from './entity-tipos-rol.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityTiposRolLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityTiposRolLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityTiposRolLoadSuccess, (state, { items }) =>
    entityTiposRolAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // update
  on(entityTiposRolUpdateSuccess, (state, { update }) =>
    entityTiposRolAdapter.upsertOne(update, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
);

export function tiposRolReducer(
  state: EntityTiposRolState | undefined,
  action: Action
) {
  return reducer(state, action);
}
